<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="600"
  >
    <v-card>
      <v-card-text>
        <v-form
          ref="formEntidadTecnicaPorExcel"
          lazy-validation
          @submit.prevent="save"
        >
          <v-card-title class="pa-2">
            Subir archivo de Excel
            <v-spacer />
          </v-card-title>

          <v-file-input
            ref="fileInputRef"
            label="Archivo Excel"
            accept=".xlsx, .xls"
            :loading="loadingJSon"
            :rules="[v => !!v || 'El archivo es obligatorio']"
            @change="previewFiles"
          />
          <v-btn
            color="primary"
            outlined
            class="mb-4"
            @click="downloadTemplate"
          >
            Descargar formato Excel
          </v-btn>

          <v-divider class="my-4" />

          <v-progress-linear
            v-if="isLoadinguploadFile"
            :value="progressUploadFile"
            height="25"
            color="blue"
          >
            <strong>{{ progressUploadFile.toFixed(0) }} %</strong>
          </v-progress-linear>

          <v-card-actions class="pa-2">
            <v-btn outlined @click="close">Cancelar</v-btn>
            <v-spacer />
            <v-btn color="primary" type="submit" :loading="loading">Guardar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import XLSX from 'xlsx'
import firebase from 'firebase'

export default {
  data () {
    return {
      dialog: false,
      loading: false,
      loadingJSon: false,
      fileExcel: '',
      data_excel: [],
      isLoadinguploadFile: false,
      progressUploadFile: 0,
      selectedFile: null
    }
  },
  methods: {
    open () {
      this.dialog = true
    },
    close () {
      this.dialog = false
      this.loading = false
      this.isLoadinguploadFile = false
      this.progressUploadFile = 0
      this.$refs.formEntidadTecnicaPorExcel.reset()
      this.selectedFile = null
    },
    previewFiles (e) {
      this.loadingJSon = true
      let file = null

      if (e && e.target && e.target.files) {
        file = e.target.files[0]
      } else {
        file = e
      }

      if (file) {
        this.selectedFile = file
        const reader = new FileReader()
        reader.readAsBinaryString(file)
        reader.onload = (event) => {
          const data = event.target.result
          const workbook = XLSX.read(data, { type: 'binary' })

          workbook.SheetNames.forEach(sheet => {
            const rows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet])
            this.data_excel = rows
          })
        }
      }

      this.loadingJSon = false
    },
    async save () {
      if (this.$refs.formEntidadTecnicaPorExcel.validate() && this.selectedFile) {
        this.loading = true
        try {
          await this.uploadToFirestore()
          await this.uploadToStorage()
          this.$emit('onUploadExcel')
          this.close()
        } catch (error) {
          console.error('Error al guardar:', error)
        } finally {
          this.loading = false
        }
      }
    },
    async uploadToFirestore () {
  const db = firebase.firestore()
  const empresas = {}
  for (const row of this.data_excel) {
    const empresa = row["Empresa"] || ''
    if (!empresas[empresa]) empresas[empresa] = []
    empresas[empresa].push({
      addressContact: row["Dirección"] || '',
      associated: empresa,
      contactName: row["Nombre"] || '',
      contactTelephone: row["Teléfono Personal"] || '',
      contactTelephone2: row["Teléfono Corporativo"] || '',
      emailContact: row["Correo Personal"] || '',
      emailContact2: row["Correo Corporativo"] || '',
      positionContact: row["Cargo"] || ''
    })
  }

  const batch = db.batch()
  for (const empresa in empresas) {
    const docRef = db.collection('contacts').doc(empresa)
    batch.set(docRef, {
      type: 3,
      contactos: empresas[empresa] 
    }, { merge: true })
  }

  await batch.commit()
},
    async uploadToStorage () {
      const storageRef = firebase.storage().ref()
      const fileName = `excels/contactos_${Date.now()}.xlsx`
      const fileRef = storageRef.child(fileName)

      const uploadTask = fileRef.put(this.selectedFile)

      return new Promise((resolve, reject) => {
        uploadTask.on('state_changed',
          snapshot => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            this.progressUploadFile = progress
            this.isLoadinguploadFile = true
          },
          error => {
            console.error('Error al subir archivo:', error)
            this.isLoadinguploadFile = false
            reject(error)
          },
          () => {
            this.isLoadinguploadFile = false
            resolve()
          }
        )
      })
    },
    downloadTemplate () {
      const worksheetData = [
        {
          "Empresa": "",
          "Nombre": "",
          "Dirección": "",
          "Teléfono Personal": "",
          "Teléfono Corporativo": "",
          "Correo Personal": "",
          "Correo Corporativo": "",
          "Cargo": ""
        }
      ]
      const worksheet = XLSX.utils.json_to_sheet(worksheetData)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, "Plantilla Contactos")
      XLSX.writeFile(workbook, "Formato_Contactos.xlsx")
    },
  }
}
</script>
